export const fetchProviderData = async provID => {
  try {
    const response = await fetch(`/wp-json/provider/v1/info/${provID}`);
    const data = await response.json();
    console.log("Data fetched:", data);
    return data;
  } catch (error) {
    console.error("Error fetching provider info:", error);
    throw error;
  }
};
